
<template>
  <div class="rightContent">
    <!-- 公司信息 -->
    <template v-if="companyTabIndex===0">
      <div class="header">
        <div class="title f_16 color_40 font_w_b">公司信息</div>
        <div class="tips f_12 color_60">完善的公司介绍，能获得更多求职者的青睐，为你带来更多查看与沟通</div>
      </div>
      <div :class="{'brandInfo': brandDisabled}" class="dataForm w450">
        <div class="item flex" :class="[errorTips.logo?'error':'']" >
          <div class="formTitle color_9c f_14 logoItem">公司logo：</div>
          <div class="flex1">
            <div class="uploadBox">
              <div class="upload pr">
                <input :disabled="brandDisabled" type="file" class="avatar-uploader pa cursor_p" ref="fileUpload" accept="image/*" @change="fileUpload">
                <template v-if="brandDisabled">
                  <img v-if="brandData.logo_hr" :src="`${brandData.logo_hr}?x-oss-process=image/resize,w_200`" class="logo pa">
                  <div class="uploadIcon text_center color_90 f_14" v-else>
                    <p class="iconfont iconupload"></p>
                    <p class="tipsName">上传头像</p>
                  </div>
                </template>
                <template v-else>
                  <img v-if="company_data.logo_hr" :src="`${company_data.logo_hr}?x-oss-process=image/resize,w_200`" class="logo pa">
                  <div class="uploadIcon text_center color_90 f_14" v-else>
                    <p class="iconfont iconupload"></p>
                    <p class="tipsName">上传头像</p>
                  </div>
                </template>
              </div>
              <!-- 错误提示 -->
            <div class="errorTipsDesc f_14" v-if="errorTips.logo">
              <span class="iconfont icontishi"></span>
              <span class="tipsName">{{errorTips.logo}}</span>
            </div>
            </div>
          </div>
          <div class="replaceCompanyBox">
            <replace-company-dialog :showReplaceCompanyBtn="showReplaceCompanyBtn" @updateCompanyInfo="updateCompanyInfo" />
          </div>
        </div>
        <div class="item flex" :class="[errorTips.name?'error':'']" >
          <div class="formTitle color_9c f_14">公司名称：</div>

          <template v-if="brandDisabled">
            <div class="flex1 companyInput pr">
              <el-input :disabled="brandDisabled" class="restInput f_14 color_40" placeholder="请输入你的公司名称" v-model="brandData.company_full_name" />
            </div>
          </template>
          <template v-else>
            <div class="flex1 companyInput pr">
              <!-- 智能联想 -->
              <el-autocomplete class="restInput f_14 color_40" :class="[errorTips.name?'error':'']" popper-class="searchCompany" :maxlength="50" placeholder="请输入你的公司名称" v-model="company_data.company_full_name" :fetch-suggestions="companySearch" @select="handleCompany" @focus="inputFocus('name')" >
                <template slot-scope="{item}">
                  <template v-if="item.token">
                    <div class="name" v-if="item.full_name.length">
                      <template v-if="item.full_name.length===1 && searchIngCompanyList[item.index].full_name===company_data.company_full_name">
                        <span class='es-highlighter'>{{item.full_name[0]}}</span>
                      </template>
                      <template v-else-if="searchIngCompanyList[item.index].full_name.indexOf(company_data.company_full_name) >-1">
                        <span v-for="(sitem,sindex) in item.full_name" :key="String(sindex)"><span class='es-highlighter' v-if="sindex == item.full_name.length-1">{{company_data.company_full_name}}</span>{{sitem}}</span>
                      </template>
                      <template v-else>
                        {{item.full_name[0]}}
                      </template>
                    </div>
                    <div class="name" v-else>
                      <span class='es-highlighter'>{{company_data.company_full_name}}</span>
                    </div>
                  </template>
                  <div @click="toCompanyAudit" class="name nullTips" v-else>没有找到公司 <span style="color: #4183ff">点击创建公司</span></div>
                </template>
              </el-autocomplete>
              <!-- 错误提示 -->
              <div class="errorTipsDesc f_14" v-if="errorTips.name">
                <span class="iconfont icontishi"></span>
                <span class="tipsName">{{errorTips.name}}</span>
              </div>
            </div>
          </template>
        </div>
        <div class="item flex" :class="[errorTips.nick_name?'error':'']">
          <div class="formTitle color_9c f_14">公司简称：</div>

          <template v-if="brandDisabled">
            <div class="flex1">
              <el-input :disabled="brandDisabled" v-model="brandData.company_nick_name" placeholder="请填写公司简称" class="restInput f_14 color_40" />
            </div>
          </template>
          <template v-else>
            <div class="flex1">
              <el-input v-model="company_data.company_nick_name" placeholder="请填写公司简称" class="restInput f_14 color_40" @focus="inputFocus('nick_name')" maxlength="10" />
              <!-- 错误提示 -->
              <div class="errorTipsDesc f_14" v-if="errorTips.nick_name">
                <span class="iconfont icontishi"></span>
                <span class="tipsName">{{errorTips.nick_name}}</span>
              </div>
            </div>
          </template>

        </div>
        <div class="item flex" :class="[errorTips.company_type?'error':'']" >
          <div class="formTitle color_9c f_14">公司类型：</div>

          <template v-if="brandDisabled">
            <div class="flex1">
              <el-select :disabled="brandDisabled" v-model="brandData.company_type" placeholder="请选择公司类型" class="restInput f_14 color_40">
                <el-option
                  v-for="item in company_options.nature_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </template>
          <template v-else>
            <div class="flex1">
              <el-select v-model="company_data.company_type" @change="inputFocus('company_type')" placeholder="请选择公司类型" class="restInput f_14 color_40">
                <el-option
                  v-for="item in company_options.nature_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <!-- 错误提示 -->
              <div class="errorTipsDesc f_14" v-if="errorTips.company_type">
                <span class="iconfont icontishi"></span>
                <span class="tipsName">{{errorTips.company_type}}</span>
              </div>
            </div>
          </template>

        </div>
        <div class="item flex" :class="[errorTips.industry?'error':'']" >
          <div class="formTitle color_9c f_14">行业类型：</div>

          <template v-if="brandDisabled">
            <div class="flex1">
              <el-select :disabled="brandDisabled" v-model="brandData.industry_id" placeholder="请选择行业类型" class="restInput f_14 color_40">
                <el-option
                  v-for="item in company_options.industry_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </template>
          <template v-else>
            <div class="flex1">
              <el-select v-model="company_data.industry_id" @change="inputFocus('industry')" placeholder="请选择行业类型" class="restInput f_14 color_40">
                <el-option
                  v-for="item in company_options.industry_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <!-- 错误提示 -->
              <div class="errorTipsDesc f_14" v-if="errorTips.industry">
                <span class="iconfont icontishi"></span>
                <span class="tipsName">{{errorTips.industry}}</span>
              </div>
            </div>
          </template>

        </div>
        <div class="item flex" :class="[errorTips.phase?'error':'']" >
          <div class="formTitle color_9c f_14">融资阶段：</div>

            <template v-if="brandDisabled">
              <div class="flex1">
                <el-select :disabled="brandDisabled" v-model="brandData.phase" placeholder="请选择融资阶段" class="restInput f_14 color_40">
                  <el-option
                    v-for="item in company_options.phase_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </template>
            <template v-else>
              <div class="flex1">
                <el-select v-model="company_data.phase" placeholder="请选择融资阶段" class="restInput f_14 color_40" @change="inputFocus('phase')">
                  <el-option
                    v-for="item in company_options.phase_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <!-- 错误提示 -->
                <div class="errorTipsDesc f_14" v-if="errorTips.phase">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{errorTips.phase}}</span>
                </div>
              </div>
            </template>

        </div>
        <div class="item flex" :class="[errorTips.scale?'error':'']" >
          <div class="formTitle color_9c f_14">公司规模：</div>

            <template v-if="brandDisabled">
              <div class="flex1">
                <el-select :disabled="brandDisabled" v-model="brandData.size" placeholder="请选择公司规模" class="restInput f_14 color_40">
                  <el-option
                    v-for="item in company_options.scale_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </template>
            <template v-else>
              <div class="flex1">
                <el-select v-model="company_data.size" placeholder="请选择公司规模" class="restInput f_14 color_40" @change="inputFocus('scale')">
                  <el-option
                    v-for="item in company_options.scale_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <!-- 错误提示 -->
                <div class="errorTipsDesc f_14" v-if="errorTips.scale">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{errorTips.scale}}</span>
                </div>
              </div>
            </template>

        </div>
        <div class="item flex" :class="[errorTips.company_url?'error':'']" >
          <div class="formTitle color_9c f_14">公司官网：</div>

            <template v-if="brandDisabled">
              <div class="flex1">
                <el-input :disabled="brandDisabled" v-model="brandData.company_website_url_hr" placeholder="https://hr.wondercv.com" class="restInput f_14 color_40" />
              </div>
            </template>
            <template v-else>
              <div class="flex1">
                <el-input v-model="company_data.company_website_url_hr" placeholder="https://hr.wondercv.com" class="restInput f_14 color_40" @focus="inputFocus('company_url')" maxlength="64" />
                <!-- 错误提示 -->
                <div class="errorTipsDesc f_14" v-if="errorTips.company_url">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{errorTips.company_url}}</span>
                </div>
              </div>
            </template>

        </div>
      </div>
      <div class="w450" v-if="!brandDisabled">
        <div class="saveButton bg_current color_fff f_14 cursor_p fr text_center" @click="saveForm()"><span class="el-icon-loading" v-if="saveFormState"></span> 保存</div>
      </div>
      <div v-if="brandDisabled" class="error-feedback f_14 cursor_p">
        <span @click="errorMessage()">信息错误反馈</span>
      </div>
    </template>
    <!-- 公司介绍 -->
    <template v-if="companyTabIndex===1">
      <div class="header">
        <div class="title f_16 color_40 font_w_b">公司介绍</div>
        <div class="tips f_12 color_60">可以简单介绍一下公司发展状况、服务领域、主要产品等信息</div>
      </div>
      <div class="description_hr pr">
        <el-input class="restInput textarea f_14 color_40"
          type="textarea"
          :rows="10"
          :maxlength="1000"
          resize="horizontal"
          placeholder="请输入公司简介"
          v-model="company_data.description_hr" @focus="inputFocus('description_hr')">
        </el-input>
        <div class="textLength textLength2 pa f_14 color_60 bg_fff">{{company_data.description_hr.length}}/1000</div>
        <!-- 错误提示 -->
        <div class="errorTipsDesc f_14" v-if="errorTips.description_hr">
          <span class="iconfont icontishi"></span>
          <span class="tipsName">{{errorTips.description_hr}}</span>
        </div>
      </div>
      <div class="saveButton bg_current color_fff f_14 cursor_p fr text_center" @click="saveForm()"><span class="el-icon-loading" v-if="saveFormState"></span> 保存</div>
    </template>
  </div>
</template>

<script>
  const oss = require('ali-oss');
  import { uuid } from 'vue-uuid';
  // 所有接口
  import actions from '@/actions/index'
  import { mapState, mapMutations } from 'vuex'
  import { legalUrl, dataURLtoBlob, blobToFile } from '@/utils/utils'
  import company_options from '@/utils/company_options'
  import ReplaceCompanyDialog from './replaceCompanyDialog'
  
  export default {
    name: 'companyRightContent',
    props: {
      firstFlag: {
        type: Boolean,
        default: false
      }
    },
    components: {
      ReplaceCompanyDialog
    },
    data() {
      return {
        company_data:{},
        getCompanyDataState:false,//是否正在请求公司信息
        company:'',//公司名称
        errorTips:{ //错误提示
          logo:'',
          name:'',
          nick_name:'',
          company_type:'',  //公司类型
          scale:'', //公司规模
          industry:'', //行业类型
          phase:'', //融资阶段
          company_url:'',//公司网址
          description_hr:'',//描述
        },
        company_options:{},
        saveFormState:false, //是否正在保存
        searchIngCompanyList:[],
        backTo:'',//保存之后返回
        edit:'', //是否编辑
        searchCompanyFocus:false, //是否ju jiao
        logoUrl:'https://logo.wondercv.com',//logo域名
        brandDisabled: false // 公司是否绑定了品牌
      }
    },
    created() {
      //读取保存之后返回的地址
      let { backTo='', edit } = this.$route.query;
      // 是否从url传递的参数
      this.backTo = backTo;
      this.edit = edit;
      this.company_options = company_options;
      // this.logoUrl = process.env.VUE_APP_ENV_TYPE === 'prod' ? 'https://logo.wondercv.com' : 'https://logo.wondercv.cn';
    },
    mounted () {
      // actions.company.get_company_companies('brand_dqRMsMFt82eAlppA',{type:'hr'})
    },
    computed: {
      ...mapState('block', ['ossOptions', 'userInfo']),
      ...mapState('company', ['companyData', 'companyTabIndex', 'brandData']),
      showReplaceCompanyBtn () {
        return this.brandDisabled
      }
    },
    methods: {
      ...mapMutations('block',['toggleUserInfoState']),
      ...mapMutations('company',['updateCompanyData','updateCompanyTabIndex', 'updateBrandData']),
      // 去公司审核
      toCompanyAudit(){
        let { href } = this.$router.resolve({
          path: '/talent/binduser',
          query: {fromEditUserInfo: true, newCompanyName: this.company_data.company_full_name, email: encodeURIComponent(this.userInfo.company_email)}
        })
        window.open(href,'_blank')
      },
      //上传之前验证
      beforeFileUpload(file) {
        const fileTypes = 'image/png,image/gif,image/jpeg,image/tif,image/tiff,image/bmp,image/x-bmp'
        const isJPG = fileTypes.indexOf(file.type)>-1;
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('上传公司logo格式错误!');
          return false;
        }
        if (!isLt2M) {
          this.$message.error('上传公司logo大小不能超过 2MB!');
          return false;
        }
        return true;
      },
      //图片上传
      fileUpload(e){
        //清空错误提示
        this.errorTips.logo = '';
        // 获取图片base64
        let file = this.$refs.fileUpload.files[0]
        if(!this.beforeFileUpload(file)){
          this.$refs.fileUpload.value = '';
          return false;
        }
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = e =>{
          const store = oss(this.ossOptions);
          let imgName = `${uuid.v1()}.${file.type.split('/')[1]}`
          //调用
          var blob = dataURLtoBlob(e.currentTarget.result);
          var fileData = blobToFile(blob, imgName);
          let downloadLoading =  this.$message({
            message: '正在上传',
            iconClass:'el-icon-loading',
            duration:0,
          });
          store.put(`companies/${imgName}`, fileData).then((res) => {
            downloadLoading.close();
            if(res.res.statusCode===200){
              this.company_data.logo_hr = `${this.logoUrl}/${res.name}`
              this.$refs.fileUpload.value = '';
              this.$message({
                message: '上传成功',
                type: 'success'
              });
            }else{
              this.$message({
                message: '图片上传失败',
                type: 'error'
              });
            }
          });
        }
      },
      //【公司】搜索公司名称
      companySearch(queryString, cb) {
        //搜索词一致，不进行搜索
        if(this.company !== queryString){
          //重置
          this.resetData();
        }
        this.company = queryString ? queryString.trim() : '';
        this.company_data.company_full_name = this.company;
        cb([]);
        if(!queryString || !queryString.trim().length){
          return false;
        }
        let query = {
          from:0,
          size:30,
          keyword:queryString
        }
        actions.company.get_company_name(query).then(res=>{
          if(res.code === 1000){
            let { companies } = res.data;
            this.searchIngCompanyList = JSON.parse(JSON.stringify(companies));
            //防止同指针，污染 searchIngCompanyList
            let companyList = [...companies];
            //拆分数据
            companyList.forEach((item,index)=>{
              let name = [item.full_name];
              item.name = item.full_name;
              if(item.full_name.indexOf(queryString)>-1){
                name = item.full_name.split(queryString).filter(sitem => sitem)
              }
              item.index = index;
              item.full_name = name
            })
            // 调用 callback 返回建议列表的数据
            cb(companyList.length ? companyList : [{token:''}]);
          }
        })
      },
      //【公司】点击筛选项
      handleCompany(item) {
        if(!item.token){
          this.company_data.company_full_name = '';
          return false
        }
        this.company_data.company_full_name = item.name;
        //获取公司详情
        this.getCompanyData(item.token);
        
      },
      //【公司】失焦
      companyBlur(){
        setTimeout(() => {
          let { company_full_name } = this.company_data
          company_full_name = company_full_name.trim();

          if(this.getCompanyDataState || !company_full_name){
            return false;
          }
          if(company_full_name.length){
            let hasCompany = false;
            this.searchIngCompanyList && this.searchIngCompanyList.forEach(item=>{
              if(item.full_name === company_full_name){
                hasCompany = true;
                if(item.token !== this.company_data.token){
                  this.getCompanyData(item.token)
                }
              }
            })
            if(!hasCompany){
              this.company_data.company_full_name = '';
              this.searchIngCompanyList = []
            }
          }
          //是否聚焦公司输入框
          this.searchCompanyFocus = false;
        }, 200);
      },
      //取消错误提示
      inputFocus(type){
        this.errorTips[type] = ''
        if(type==='name'){
          //是否聚焦公司输入框
          this.searchCompanyFocus = true;
        }
      },
      //保存表单
      async saveForm(){
        let { logo_hr,company_full_name, company_nick_name, company_type, industry_id, phase, size, company_website_url_hr, description_hr, size_min,size_max } = this.company_data;
        //是否聚焦公司输入框
        // if(this.searchCompanyFocus){
        //   return false;
        // }
        if(this.companyTabIndex===0){
          let formState = true;
          if(!logo_hr){
            this.errorTips.logo = '请上传公司logo';
            formState = false;
          }
          if(!company_full_name){
            this.errorTips.name = '请填写公司名称';
            formState = false;
          }
          if(!company_nick_name){
            this.errorTips.nick_name = '请填写公司简称';
            formState = false;
          }
          if(!company_type){
            this.errorTips.company_type = '请选择公司类型';
            formState = false;
          }
          if(!industry_id){
            this.errorTips.industry = '请选择行业类型';
            formState = false;
          }
          if(!phase){
            this.errorTips.phase = '请选择融资阶段';
            formState = false;
          }
          if(!size){
            this.errorTips.scale = '请选择公司规模';
            formState = false;
          }
          if(company_website_url_hr && !legalUrl(company_website_url_hr)){
            this.errorTips.company_url = '请填写正确的公司官网地址';
            formState = false;
          }
          // if(!company_website_url_hr){
          //   this.errorTips.company_url = '请填写公司官网地址';
          //   formState = false;
          // }else if(!legalUrl(company_website_url_hr)){
          //   this.errorTips.company_url = '请填写正确的公司官网地址';
          //   formState = false;
          // }
          if(!formState){
            return false;
          }
          size_min = Number(size.split(',')[0]);
          size_max = Number(size.split(',')[1]);
          this.company_data.size_min = size_min;
          this.company_data.size_max = size_max;

          if(this.saveFormState){
            return false;
          }
          let data = {
            logo_hr,
            company_full_name,
            company_nick_name:company_nick_name||'',
            company_type,
            industry_id,
            phase,
            size_min:size_min,
            size_max:size_max,
            company_website_url_hr
          }
          this.saveFormState = true;
          //是否已经绑定公司
          let hasCompanyToken = !!this.userInfo.company_token;
          //先绑定公司
          if(this.company_data.token !== this.userInfo.company_token){
            try {
              await actions.hr_accounts.bind_companies(this.company_data.token);
              let userInfo = await actions.hr_accounts.getUserinfo();
              this.toggleUserInfoState(userInfo);
              // hr更换公司后下线之前线上职位
              await actions.hr_accounts.offlineJobStatus()
            } catch (e) { console.log(e) }
          }
          //更新公司信息
          actions.company.put_company_companies(this.company_data.token,data).then(async res=>{
            this.saveFormState = false;
            if(res.code === 1000){
              let companyData = JSON.parse(JSON.stringify(this.companyData));
              companyData.logo_hr = logo_hr;
              companyData.company_full_name = company_full_name;
              companyData.company_nick_name = company_nick_name;
              companyData.company_type = company_type;
              companyData.industry_id = industry_id;
              companyData.phase = phase;
              companyData.size = size;
              companyData.size_min = size_min;
              companyData.size_max = size_max;
              companyData.company_website_url_hr = company_website_url_hr;
              //同步数据到vuex
              this.updateCompanyData(companyData)
              this.$message.success('公司信息修改成功');
              // 判断修改后的公司有没有绑定品牌
              if (companyData.brand_token) {
                this.getCompanyData(companyData.brand_token, true)
                this.brandDisabled = true
              }
              if((!hasCompanyToken || this.edit) && this.backTo){
                 setTimeout(() => {
                    window.location.href = decodeURIComponent(this.backTo);
                  }, 1000);
                  return false;
              }
            }else{
              this.$message({
                message:res.message,
                type:'error'
              })
            }
          })
        }else if(this.companyTabIndex===1){
          let formState = true;
          if(!description_hr){
            this.errorTips.description_hr = '请填写公司介绍';
            formState = false;
          }else if(description_hr.length<50){
            this.errorTips.description_hr = '公司介绍不少于50字';
            formState = false;
          }
          if(!formState){
            return false;
          }
          let data = {
            description_hr
          }
          this.saveFormState = true;
          actions.company.put_company_companies(this.company_data.token,data).then(res=>{
            this.saveFormState = false;
            if(res.code === 1000){
              let companyData = JSON.parse(JSON.stringify(this.companyData));
              companyData.description_hr = description_hr;
              //同步数据到vuex
              this.updateCompanyData(companyData)
              this.$message.success('公司介绍修改成功');
            }else{
              this.$message({
                message:res.message,
                type:'error'
              })
            }
          })
        }
      },
      //重新获取公司信息
      getCompanyData(token, isBrandToken, callback){
        actions.company.get_company_companies(token,{type:'hr'}).then(res=>{
          if(res.code === 1000){
            let { company_website_url, company_website_url_hr, size_min, size_max, logo, logo_hr, description, description_hr, benefits, industry_id, industry } = res.data;
            //网址判断
            res.data.company_website_url_hr = company_website_url_hr || company_website_url || '';
            //logo判断
            res.data.logo_hr = logo_hr || logo || '';
            //描述判断
            res.data.description_hr = description_hr || description || '';
            //公司规模
            res.data.size = ''
            if(size_max){
              company_options.scale_options.forEach(item=>{
                if(size_max<=item.max && !res.data.size){
                  res.data.size = item.value
                }
              })
            }
            
            //整理福利
            let benefit_detail = [];
            for(let i=0; i<4; i++){
              let bitem = {
                    id:i,
                    list:[]
                  }
              benefits.benefit_detail && benefits.benefit_detail.forEach((item,index)=>{
                if(item.id===i){
                  bitem = item
                }
              })
              benefit_detail.push(bitem)
            }
            if(industry_id && industry && industry.cn){
              company_options.industry_options.forEach(item=>{
                if(industry.cn === item.label){
                  res.data.industry_id = item.value
                }
              })
            }
            benefits.benefit_detail = benefit_detail;
            // 判断获取的是公司信息还是品牌信息，然后更新公司或者品牌信息
            if (isBrandToken) {
              this.updateBrandData(res.data);
              console.log('这是品牌信息', res.data)
            } else {
              this.updateCompanyData(res.data);
            }
            callback && callback(res.data)
            //重置错误提示
            this.errorTips = { //错误提示
              logo:'',
              name:'',
              company_type:'',  //公司类型
              scale:'', //公司规模
              industry:'', //行业类型
              phase:'', //融资阶段
              company_url:'',//公司网址
              description_hr:'',//描述
            }
          }
        }) 
      },
      //重新上传
      resetData(){
        this.company_data = {
          company_full_name:'',
          company_nick_name:'',
          logo_hr:'',
          company_type:'',
          industry_id:'',
          phase:'',
          size:'',
          company_website_url_hr:'',
          description_hr:'',
          benefits:{
            benefit_detail:[],
          },
          intro_picture:[],
          products:[],
          executive:[],
        }
        //同步数据到vuex
        this.updateCompanyData(this.company_data)
      },
      // 修改公司后更新公司信息展示
      updateCompanyInfo (token) {
        this.getCompanyData(token, false, (data) => {
          // 拿到公司详情后，判断是否绑定了品牌，如果绑定了品牌，获取品牌信息并且展示，不可编辑
          if (data.brand_token) {
            this.getCompanyData(data.brand_token, true)
            this.brandDisabled = true
          } else {
            this.brandDisabled = false
          }
        })
      },
      // 弹出客服
      errorMessage () {
        let udesk_container = document.querySelector('#udesk_btn a')
        if(udesk_container!=null){
          udesk_container.click()
        }
      }
    },
    watch:{
      companyData :{
        handler: function (val, oldVal) {
          if(val.token===this.company_data.token){
            let { logo_hr,company_full_name, company_nick_name, company_type, industry_id, phase, size, company_website_url_hr, description_hr } = this.company_data;
            if(logo_hr!=val.logo_hr || company_full_name!=val.company_full_name || company_nick_name!=val.company_nick_name || company_type!=val.company_type || industry_id!=val.industry_id || phase!=val.phase || size!=val.size || company_website_url_hr!=val.company_website_url_hr ||  description_hr!=val.description_hr){
              console.log('rightContent阻止更新')
              return false;
            }
          }
          this.company_data = JSON.parse(JSON.stringify(val));
          this.company = this.company_data.company_full_name;
        },
        deep: true
      },
      // 页面初次渲染 第一次获取公司信息后，判断公司是否绑定了品牌，如果绑定了品牌，需要展示品牌信息并且不可编辑
      firstFlag: {
        handler: function (val) {
          if (val) {
            if (this.company_data.brand_token) {
              this.getCompanyData(this.company_data.brand_token, true)
              this.brandDisabled = true
            }
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './rightContent.scss';
</style>
